export const images = [
    { id:1, original: '/images/services/2/sub-categories/5/c2-s5-p1.jpg' },
]
